import { heroFeature } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute inset-0 paper-grid opacity-40"></div>
      <div className="relative mx-auto max-w-shell px-4 pb-16 pt-14 md:px-6 md:pb-24 md:pt-20">
        <div className="grid grid-cols-1 items-stretch gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
          <div className="anim-fade-up flex flex-col justify-center">
            <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs tracking-wide text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
              {heroFeature.kicker}
            </span>

            <h1 className="mt-6 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.2]">
              黑料社网
              <span className="mt-2 block text-xl font-bold text-foreground-700 md:text-2xl">
                {heroFeature.headline}
              </span>
            </h1>

            <p className="mt-6 max-w-xl font-body text-sm leading-8 text-foreground-600 md:text-base">
              {heroFeature.lead}
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#archive"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-archive-line text-base"></i>
                浏览全部存档
              </a>
              <a
                href="#comments"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-500 hover:bg-secondary-50 hover:text-secondary-900"
              >
                <i className="ri-chat-3-line text-base"></i>
                看热评现场
              </a>
            </div>

            <dl className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-background-200 pt-6">
              <div>
                <dt className="font-label text-xs text-foreground-500">当前游览的是</dt>
                <dd className="mt-1 font-heading text-base font-bold text-foreground-900">
                  首页 · 存档总览
                </dd>
              </div>
              <div>
                <dt className="font-label text-xs text-foreground-500">最近一次补录</dt>
                <dd className="mt-1 font-heading text-base font-bold text-foreground-900">
                  2024 年 11 月 08 日
                </dd>
              </div>
            </dl>
          </div>

          <div className="anim-fade-in relative">
            <div className="relative h-[300px] w-full overflow-hidden rounded-lg border border-background-200 sm:h-[380px] lg:h-full lg:min-h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20editorial%20archive%20room%20with%20stacks%20of%20old%20newspapers%20and%20dossiers%2C%20warm%20amber%20and%20deep%20crimson%20rim%20lighting%2C%20dust%20particles%20in%20a%20single%20spotlight%20beam%2C%20cinematic%20chiaroscuro%2C%20textured%20aged%20paper%2C%20mysterious%20investigation%20atmosphere%2C%20muted%20warm%20background&width=1000&height=1240&seq=heliao-hero-2024&orientation=portrait"
                alt="黑料社网往期回顾历史存档配图"
                title="黑料社网 历史存档 翻旧账 往期回顾"
                className="h-full w-full object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>

              <div className="absolute left-4 top-4 flex items-center gap-2 rounded-full bg-background-50/90 px-3 py-1 font-label text-xs text-primary-700">
                <i className="ri-bookmark-3-line text-sm"></i>
                {heroFeature.featureKicker}
              </div>

              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                <div className="flex flex-wrap gap-2">
                  {heroFeature.featureTags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-accent-500/90 px-2.5 py-1 font-label text-[11px] text-foreground-950"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                  {heroFeature.featureTitle}
                </h2>
                <p className="mt-2 line-clamp-2 font-body text-xs leading-6 text-background-200">
                  {heroFeature.featureSummary}
                </p>
              </div>
            </div>

            <ul className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2">
              {heroFeature.featureMeta.map((meta) => (
                <li key={meta} className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
                  <span className="h-1 w-1 rounded-full bg-primary-400"></span>
                  {meta}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}